import styled from 'styled-components';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Introduction3 = () => {
    useEffect(() => {
        AOS.init({
            duration: 800,
            offset: 0,
        });
    }, []);

    return (
        <Wrap>
            <div className="con flex aic jcsb rel">
                <div id='contact' className='abs y-b x-l'></div>
                <LeftBox data-aos="fade-right" data-aos-delay="300">
                    <div className="text-box">
                        <h1 className='tb'>더 <span className='tb inblock'>간편한</span><br/>발급 시스템</h1>
                        <p className='lh140'>발급부터 기관 제출까지 간편하게.</p>
                    </div>
                </LeftBox>
                <RightBox data-aos="fade-left" data-aos-delay="700">
                    <ul className='flex'>
                        <li>
                            <h2 className="tsb">Step.1</h2>
                            <h3 className='tb'>이용자 관리</h3>
                            <span className="img-box">
                                <img src="./img/introduction3_img_1.png" alt="" />
                            </span>
                        </li>
                        <li>
                            <h2 className="tsb">Step.2</h2>
                            <h3 className="tb">PASS 앱으로 한 번에</h3>
                            <span className="img-box">
                                <img src="./img/introduction3_img_2.png" alt="" />
                            </span>
                        </li>
                    </ul>
                    <ul className='flex'>
                        <li>
                            <h2 className="tsb">Step.3</h2>
                            <h3 className="tb">손쉬운 증명</h3>
                            <span className="img-box">
                                <img src="./img/introduction3_img_3.png" alt="" />
                            </span>
                        </li>
                        <li>
                            <h2 className="tsb">Step.4</h2>
                            <h3 className="tb">공공기관 제출까지</h3>
                            <span className="img-box">
                                <img src="./img/introduction3_img_4.png" alt="" />
                            </span>
                        </li>
                    </ul>
                </RightBox>
            </div>
        </Wrap>
    );
}

export default Introduction3;

const Wrap = styled.div`
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 100px 0;
    @media (max-width: 1400px) {
        padding: 7.1428vw 0;
    }
    @media (max-width: 767px) {
        padding: 50px 0;

        .con {
            flex-direction: column;
        }
    }
`
const LeftBox = styled.div`
    .text-box {
        @media (max-width: 767px) {
            text-align: center;
        }

        > h1 {
            font-size: 55px;
            line-height: 60px;
            color: #282828;
            @media (max-width: 1400px) {
                font-size: 3.9285vw;
                line-height: 4.2857vw;
            }
            @media (max-width: 767px) {
                font-size: 30px;
                line-height: 40px;
            }
            
            > span {
                line-height: 60px;
                color: ${props => props.theme.mainColor1};
                @media (max-width: 1400px) {
                    line-height: 4.2857vw;
                }
                @media (max-width: 767px) {
                    line-height: 40px;
                }
            }
        }

        > p {
            margin-top: 24px;
            font-size: 24px;
            line-height: 28px;
            color: #282828;
            @media (max-width: 1400px) {
                margin-top: 1.7142vw;
                font-size: 1.7142vw;
                line-height: 2vw;
            }
            @media (max-width: 767px) {
                margin-top: 12px;
                font-size: 18px;
                line-height: 28px;
            }
        }
    }
`
const RightBox = styled.div`
    width: 925px;
    @media (max-width: 1400px) {
        width: 66.0714vw;
    }
    @media (max-width: 767px) {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 24px;
        margin-top: 24px;
    }

    ul {
        width: 100%;
        gap: 24px;
        @media (max-width: 1400px) {
            gap: 1.7142vw;
        }
        @media (max-width: 767px) {
            gap: 24px;
            flex-direction: column;
        }

        > li {
            width: calc(50% - 12px);
            height: 331px;
            background-color: #F6F6F6;
            border-radius: 20px;
            box-sizing: border-box;
            padding: 24px 0 0 24px;
            overflow: hidden;
            box-shadow: 0px 4px 20px 0px rgba(161, 161, 161, 0.25);
            &:nth-child(2) {
                margin-top: 24px;
            }
            @media (max-width: 1400px) {
                width: calc(50% - 0.8571vw);
                height: 23.6428vw;
                border-radius: 1.4285vw;
                padding: 1.7142vw 0 0 1.7142vw;
                box-shadow: 0px 0.2857vw 1.7142vw 0px rgba(161, 161, 161, 0.25);
                &:nth-child(2) {
                    margin-top: 1.7142vw;
                }
            }
            @media (max-width: 767px) {
                width: 100%;
                height: auto;
                padding: 24px 0 0 24px;
                box-shadow: 0px 4px 20px 0px rgba(161, 161, 161, 0.25);
                &:nth-child(2) {
                    margin-top: 0;
                }
            }

            > h2 {
                font-size: 20px;
                line-height: 28px;
                color: #000;
                opacity: 0.5;
                @media (max-width: 1400px) {
                    font-size: 1.4285vw;
                    line-height: 2vw;
                }
                @media (max-width: 767px) {
                    font-size: 16px;
                    line-height: 24px;
                }
            }

            > h3 {
                font-size: 30px;
                line-height: 40px;
                margin-top: 8px;
                @media (max-width: 1400px) {
                    font-size: 2.1428vw;
                    line-height: 2.8571vw;
                    margin-top: 0.5714vw;
                }
                @media (max-width: 767px) {
                    font-size: 20px;
                    line-height: 28px;
                    margin-top: 8px;
                }
            }

            > .img-box {
                margin-top: 12px;
                @media (max-width: 1400px) {
                    margin-top: 0.8571vw;
                }
                @media (max-width: 767px) {
                    margin-top: 12px;
                }
            }
        }
    }
`